import React from "react";
import { Link } from "react-router-dom";

import testnetDashboardPc from "../../images/blog/dash_pc.png";
import testnetDashboardMobile from "../../images/blog/dash_mb.png";

const TESTNET_STEPS = [
  {
    id: "(01)",
    text: "Join our whitelist and get early rewards at launch."
  },
  {
    id: "(02)",
    text: (
      <>
        Visualize our ATOM testnet and see how it works and its robust, advanced infrastructure.{" "}
        <a
          href="https://dashboard.atomfoundation.io/"
          className="testnet-inline-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          Click Here
        </a>
      </>
    )
  },
  {
    id: "(03)",
    text: "In 2026, ATOM will launch its network to the market, driving token growth with real-world utility and performance."
  },
  {
    id: "(04)",
    text: "We are developing the most technologically advanced institutional Layer 3 network in the US."
  }
];

const leftSteps = [TESTNET_STEPS[0], TESTNET_STEPS[2]];
const rightSteps = [TESTNET_STEPS[1], TESTNET_STEPS[3]];

const TestnetSection: React.FC = () => {
  return (
    <section className="testnet-section pt-60 pb-1">
      <div className="container">
        <div className="sec-title sec-title-center text-center mb-120 testnet-sec-title">
          <span className="sub-title mb-25">Atom Testnet</span>
          <h2 className="title">Join The Whitelist and View Sample Test Network</h2>
        </div>

        <div className="testnet-inner">
          <div className="testnet-card">
            <div className="row align-items-center testnet-layout-row">
              {/* Left text column */}
              <div className="col-lg-3 col-md-4 testnet-col-left">
                <div className="testnet-list testnet-list-left">
                  {leftSteps.map((step) => (
                    <div className="testnet-list-item" key={step.id}>
                      <span className="testnet-list-label">{step.id}</span>
                      <p>{step.text}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Center stacked images */}
              <div className="col-lg-6 col-md-8 testnet-col-center">
                <div className="testnet-visual-wrapper">
                  <div
                    className="testnet-image-desktop wow zoomIn"
                    data-wow-duration="1200ms"
                  >
                    <img
                      src={testnetDashboardPc}
                      alt="Atom Testnet dashboard"
                      className="img-fluid"
                    />
                  </div>

                  <div
                    className="testnet-image-mobile wow zoomIn"
                    data-wow-duration="1200ms"
                    data-wow-delay="500ms"
                  >
                    <img
                      src={testnetDashboardMobile}
                      alt="Atom Testnet mobile dashboard"
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>

              {/* Right text column */}
              <div className="col-lg-3 col-md-4 testnet-col-right">
                <div className="testnet-list testnet-list-right">
                  {rightSteps.map((step) => (
                    <div className="testnet-list-item" key={step.id}>
                      <span className="testnet-list-label">{step.id}</span>
                      <p>{step.text}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Mobile stacked list */}
              <div className="col-12 testnet-col-mobile">
                <div className="testnet-list testnet-list-mobile">
                  {TESTNET_STEPS.map((step) => (
                    <div className="testnet-list-item" key={`mobile-${step.id}`}>
                      <span className="testnet-list-label">{step.id}</span>
                      <p>{step.text}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="col-12 testnet-col-cta">
                <div className="testnet-cta">
                  <Link className="thm-btn agency-btn" to="/visual-network">
                    <span className="text">Visual Network - Testnet</span>
                    <span className="arrow">
                      <span className="arrow-icon">
                        <svg
                          width="28"
                          height="28"
                          viewBox="0 0 28 28"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="5.06592"
                            y="19.9785"
                            width="20.5712"
                            height="2.61221"
                            transform="rotate(-40.2798 5.06592 19.9785)"
                            fill="white"
                          />
                          <rect
                            x="7.97095"
                            y="7.24463"
                            width="2.61221"
                            height="2.61221"
                            transform="rotate(-40.2798 7.97095 7.24463)"
                            fill="white"
                          />
                          <rect
                            x="11.6523"
                            y="7.54834"
                            width="2.61221"
                            height="2.61221"
                            transform="rotate(-40.2798 11.6523 7.54834)"
                            fill="white"
                          />
                          <rect
                            x="15.334"
                            y="7.85205"
                            width="2.61221"
                            height="2.61221"
                            transform="rotate(-40.2798 15.334 7.85205)"
                            fill="white"
                          />
                          <rect
                            x="18.7119"
                            y="11.8374"
                            width="2.61221"
                            height="2.61221"
                            transform="rotate(-40.2798 18.7119 11.8374)"
                            fill="white"
                          />
                          <rect
                            x="18.4084"
                            y="15.52"
                            width="2.61221"
                            height="2.61221"
                            transform="rotate(-40.2798 18.4084 15.52)"
                            fill="white"
                          />
                          <rect
                            x="18.104"
                            y="19.2012"
                            width="2.61221"
                            height="2.61221"
                            transform="rotate(-40.2798 18.104 19.2012)"
                            fill="white"
                          />
                        </svg>
                        <svg
                          width="28"
                          height="28"
                          viewBox="0 0 28 28"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="5.06592"
                            y="19.9785"
                            width="20.5712"
                            height="2.61221"
                            transform="rotate(-40.2798 5.06592 19.9785)"
                            fill="white"
                          />
                          <rect
                            x="7.97095"
                            y="7.24463"
                            width="2.61221"
                            height="2.61221"
                            transform="rotate(-40.2798 7.97095 7.24463)"
                            fill="white"
                          />
                          <rect
                            x="11.6523"
                            y="7.54834"
                            width="2.61221"
                            height="2.61221"
                            transform="rotate(-40.2798 11.6523 7.54834)"
                            fill="white"
                          />
                          <rect
                            x="15.334"
                            y="7.85205"
                            width="2.61221"
                            height="2.61221"
                            transform="rotate(-40.2798 15.334 7.85205)"
                            fill="white"
                          />
                          <rect
                            x="18.7119"
                            y="11.8374"
                            width="2.61221"
                            height="2.61221"
                            transform="rotate(-40.2798 18.7119 11.8374)"
                            fill="white"
                          />
                          <rect
                            x="18.4084"
                            y="15.52"
                            width="2.61221"
                            height="2.61221"
                            transform="rotate(-40.2798 18.4084 15.52)"
                            fill="white"
                          />
                          <rect
                            x="18.104"
                            y="19.2012"
                            width="2.61221"
                            height="2.61221"
                            transform="rotate(-40.2798 18.104 19.2012)"
                            fill="white"
                          />
                        </svg>
                      </span>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestnetSection;
